import { lazy } from 'react';

/**
 * Every tool in the Tools section.
 *   id        – URL segment: /tools/:id
 *   component – lazy tool body, rendered inside ToolRoute's page shell
 *   image     – tile image in /public/images (optional; falls back to icon tile)
 *   icon      – Material icon name for the generated tile
 *   category  – hub grouping
 */
export const TOOLS = [
  {
    id: 'brake-bias',
    name: 'Brake Bias',
    description: 'Hydraulic brake balance, pedal effort and front axle load against deceleration.',
    image: 'brake-bias-calculator.jpg',
    icon: 'album',
    category: 'Brakes & Tires',
    component: lazy(() => import('./BrakeBias/BrakeBias')),
  },
  {
    id: 'tire-size',
    name: 'Tire Size',
    description: 'Compare two tire and wheel combinations: diameter, sidewall position and speedo error.',
    image: 'tire-size-calculator.jpg',
    icon: 'tire_repair',
    category: 'Brakes & Tires',
    component: lazy(() => import('./TireSize/TireSize')),
  },
  {
    id: 'alignment',
    name: 'Alignment Angle ↔ Distance',
    description: 'Convert toe between degrees and mm/in at the tire for your alignment rig.',
    image: 'alignment-calculator.jpg',
    icon: 'straighten',
    category: 'Chassis & Suspension',
    component: lazy(() => import('./Alignment/Alignment')),
  },
  {
    id: 'wheel-rate',
    name: 'Wheel Rate',
    description: 'Spring rate to wheel rate through the motion ratio, with ride frequency and static load.',
    image: 'wheel-rate-calculator.jpg',
    icon: 'height',
    category: 'Chassis & Suspension',
    component: lazy(() => import('./WheelRate/WheelRate')),
  },
  {
    id: 'suspension-kinematics',
    name: 'Suspension Kinematics',
    description: '3D double wishbone, dual lower ball joint, multi-link and MacPherson solver with bump and roll about the roll centre.',
    icon: 'view_in_ar',
    tag: 'New',
    category: 'Chassis & Suspension',
    component: lazy(() => import('./SuspensionKinematics/SuspensionKinematics')),
  },
  {
    id: 'battery-sizing',
    name: 'Battery Sizing',
    description: 'Size an EV race pack from power, regen and energy use per minute, with I²R heating and a cooling model.',
    icon: 'battery_charging_full',
    tag: 'New',
    category: 'Powertrain',
    component: lazy(() => import('./BatterySizing/BatterySizing')),
  },
  {
    id: 'efficiency-tracker',
    name: 'Efficiency Tracker',
    description: 'Log steady-speed runs per configuration and fit efficiency vs speed against a CdA / Crr road-load model, with elevation correction.',
    icon: 'speed',
    tag: 'New',
    category: 'Powertrain',
    component: lazy(() => import('./EfficiencyTracker/EfficiencyTracker')),
  },
];

export const CATEGORIES = ['Chassis & Suspension', 'Brakes & Tires', 'Powertrain'];

export const getTool = (id) => TOOLS.find((t) => t.id === id);
